export const FACEBOOK_DOMAIN_VERIFICATION = 'f92t0uplvps67mih9c8o4w81dg92vm';

export const TAG_MAPPING_BY_EXPERIENCE_ID = {
  '6U5XVMG3q76hL8vZy73cwp': 'KIDS_CLUB',
  JLp4zrOWQ72iMVvq2f2IR: 'SPORTS',
  '6GnimoTv8SGizZF9VrdBQ9': 'ROMANCE',
  '3KTEWkzR9nm0uhVtc5CtNo': 'WATERSPORTS',
  '2vJgvmI07NXtOP6JPrsZuk': 'FITNESS',
  '2IgAUhCPA548GRTqYh9kzn': 'WELLNESS',
  '2GP1mUwJeiumhmTXaLmZbh': 'ENTERTAINMENT',
  '37C3lr2XWsp804sqgx27FB': 'ALL_INCLUSIVE',
  '33u91fnkSFwoBkbMBIrV8O': 'BEACH',
  '56WCDBxkypCGP6lzYTaMMH': 'MOUNTAIN',
  '2XO80uTrPHK1oeVAdSmH7O': 'URBAN',
  '6I2wT5iUCTluelzrDO8aZq': 'THEME_PARK',
  '3c5VMiwkb1XXFoDzpnxA94': 'ADULTS_ONLY',
};

export const TAG_MAPPING_BY_EXPERIENCE_TITLE = {
  'Kids Club': 'KIDS_CLUB',
  Sports: 'SPORTS',
  Romance: 'ROMANCE',
  Watersports: 'WATERSPORTS',
  Fitness: 'FITNESS',
  Wellness: 'WELLNESS',
  Entertainment: 'ENTERTAINMENT',
  'All Inclusive': 'ALL_INCLUSIVE',
  Beach: 'BEACH',
  Mountain: 'MOUNTAIN',
  Urban: 'URBAN',
  'Theme Park': 'THEME_PARK',
  'Adults Only': 'ADULTS_ONLY',
};
